var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLawnCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4221_1666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4221_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13151 16.5866C9.00651 16.2242 8.84679 15.8897 8.65234 15.583C8.4579 15.2763 8.22873 14.9906 7.96484 14.7259C7.70095 14.4611 7.41623 14.2293 7.11068 14.0305C6.80512 13.8318 6.47179 13.6699 6.11068 13.5449C6.13845 13.9477 6.23568 14.3227 6.40234 14.6699C6.56901 15.0171 6.79123 15.3296 7.06901 15.6074C7.34679 15.8852 7.65929 16.1095 8.00651 16.2805C8.35373 16.4515 8.72873 16.5535 9.13151 16.5866ZM10.8607 16.5866C11.2635 16.5503 11.6391 16.4488 11.9878 16.2822C12.3365 16.1155 12.6504 15.8933 12.9294 15.6155C13.2083 15.3377 13.4311 15.0239 13.5978 14.6741C13.7644 14.3241 13.866 13.9477 13.9023 13.5449C13.5425 13.6699 13.2069 13.8296 12.8955 14.0241C12.5841 14.2185 12.2969 14.4477 12.0338 14.7116C11.7709 14.9754 11.5412 15.2636 11.3448 15.5761C11.1483 15.8886 10.9869 16.2254 10.8607 16.5866ZM10.0001 9.40718C10.9007 9.40718 11.6681 9.09016 12.3021 8.45613C12.9362 7.82197 13.2532 7.05461 13.2532 6.15405V4.91363L11.7948 6.1428L10.0001 3.87197L8.20526 6.1428L6.74693 4.91363V6.15405C6.74693 7.05461 7.06394 7.82197 7.69797 8.45613C8.332 9.09016 9.09936 9.40718 10.0001 9.40718ZM9.42318 17.8366C8.14998 17.8366 7.06783 17.391 6.17672 16.4999C5.28547 15.6086 4.83984 14.5264 4.83984 13.2532V12.0513C5.77248 12.1123 6.63894 12.3711 7.43922 12.8278C8.23936 13.2846 8.88464 13.8698 9.37505 14.5834V10.6186C8.27144 10.4722 7.34915 9.9787 6.60818 9.13801C5.86734 8.29718 5.49693 7.30252 5.49693 6.15405V3.81738C5.49693 3.48836 5.64325 3.25898 5.93589 3.12926C6.22866 2.9994 6.4979 3.04183 6.74359 3.25655L8.04484 4.38155L9.41026 2.65551C9.5629 2.47176 9.75998 2.37988 10.0015 2.37988C10.243 2.37988 10.4391 2.47176 10.5898 2.65551L11.9553 4.38155L13.2565 3.25655C13.5022 3.04183 13.7714 2.9994 14.0642 3.12926C14.3569 3.25898 14.5032 3.48836 14.5032 3.81738V6.15405C14.5032 7.30252 14.1328 8.29718 13.3919 9.13801C12.651 9.9787 11.7287 10.4722 10.6251 10.6186V14.5755C11.1155 13.8672 11.7594 13.2846 12.5569 12.8278C13.3544 12.3711 14.2169 12.1123 15.1442 12.0513V13.2532C15.1442 14.5264 14.6994 15.6086 13.8098 16.4999C12.9201 17.391 11.8398 17.8366 10.569 17.8366H9.42318Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawnCare);
export default __webpack_public_path__ + "static/media/lawn_care.cffe2b97.svg";
export { ForwardRef as ReactComponent };